import { Injectable } from '@angular/core';
import { LoggerFactory } from '../providers/logger/logger-factory.service';
import { LoggerWrapper } from '../providers/logger/logger-wrapper.service';
import { Browser } from '@capacitor/browser';

@Injectable({ providedIn: 'root' })
export class ExternalLinkService {
  private logger: LoggerWrapper;

  constructor(private loggerFactory: LoggerFactory) {
    this.logger = this.loggerFactory.getInstance(this);
  }

  async ouvrirLien(url: string): Promise<void> {
    this.logger.log('go to _blank', url);
    await Browser.open({ url: url });
  }
}
